/* eslint-disable @typescript-eslint/naming-convention */
import { JuspayRedirectResponse } from "@payment-client/interfaces/JuspayRedirect";
import { JUSPAY_REDIRECT_URL, JUSPAY_TOKENIZE_URL } from "@payment-client/constants/Juspay";
import { nrErrorLog } from "@payment-client/utils/Api";
import { recordNREvent, NEWRELIC_TABLES } from "@swiggy-private/checkout-core";
import { isEmpty } from "@swiggy-private/js-utils";

interface JuspayErrorResponse {
    status?: string;
    error_message?: string;
    error_code?: string;
    error_info?: {
        user_message?: string;
        developer_message?: string;
    };
}

function getJuspayErrorMessage(response?: JuspayErrorResponse, httpStatus?: number): string {
    if (isEmpty(response) || httpStatus === 200) {
        return "-";
    }
    return `status: ${response?.status} error_message: ${response?.error_message} error_code: ${response?.error_code}`;
}

export async function juspayRedirect(
    serializedPaymentData: string,
    merchantId: string,
): Promise<JuspayRedirectResponse> {
    const startTime = Date.now();
    const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-merchantid": merchantId,
    };
    try {
        const data = await fetch(JUSPAY_REDIRECT_URL, {
            method: "POST",
            mode: "cors",
            body: serializedPaymentData,
            headers,
        });

        const response = await data.json();

        // Log success scenario with response time
        recordNREvent({
            url: JUSPAY_REDIRECT_URL,
            eventType: NEWRELIC_TABLES.PAYMENT_WEB_EXTERNAL_API,
            method: "POST",
            responseTime: Date.now() - startTime,
            statusCode: data.status,
            statusMessage: getJuspayErrorMessage(response as JuspayErrorResponse, data.status),
        });

        return response;
    } catch (error) {
        nrErrorLog({ startTime, url: JUSPAY_REDIRECT_URL }, error);
        throw error;
    }
}

export async function juspayTokenize(
    serializedPaymentData: string,
    merchantId: string,
): Promise<{
    token: string;
}> {
    const startTime = Date.now();
    const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-merchantid": merchantId,
    };
    try {
        const data = await fetch(JUSPAY_TOKENIZE_URL, {
            method: "POST",
            mode: "cors",
            body: serializedPaymentData,
            headers,
        });

        const response = await data.json();

        // Log success scenario with response time
        recordNREvent({
            url: JUSPAY_TOKENIZE_URL,
            eventType: NEWRELIC_TABLES.PAYMENT_WEB_EXTERNAL_API,
            method: "POST",
            responseTime: Date.now() - startTime,
        });

        return response;
    } catch (error) {
        nrErrorLog({ startTime, url: JUSPAY_TOKENIZE_URL }, error);
        throw error;
    }
}
